import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface SurCreditMemoModel {
    searchparameter: StoreParameter;
    parameter: CreditMemoParameter;
    creditdata: any;
    uri: string;
    creditMemos: CreditMemo[];
    pagination: CreditMemoPagination;
    properties: Properties2;
}

export interface CreditMemo {
    uri: string;
    creditMemoNumber: string;
    creditDate: string;
    poNumber: string;
    amount: number;
    amountDisplay:string;
    applyToInvoiceNo:string;
    properties: Properties;
}

export interface Properties {}

export interface CreditMemoPagination {
    currentPage: number;
    page: number;
    pageSize: number;
    defaultPageSize: number;
    totalItemCount: number;
    numberOfPages: number;
    pageSizeOptions: number[];
    sortOptions: SortOption[];
    sortType: string;
    nextPageUri: string;
    prevPageUri: string;
}

export interface SortOption {
    displayName: string;
    sortType: string;
}

export interface Properties2 {}

export interface CreditDataResultModel {}

export interface CreditMemoParameter extends ApiParameter {
    poNumber?: string | null;
    invoiceNumber?: string | null;
    creditDate?: string;
    beginDate?: string | null;
    pageSize?: number;
    isLoad?: boolean;
    endDate?: string | null;
    sort?: string;
    customerSequence?: string;
    page?: number;
    serachedParameter?: object | string;
}
export interface StoreParameter {
    poNumber?: string;
    invoiceNumber?: string;
    creditDate?: string;
    beginDate?: string;
    pageSize?: number;
    endDate?: string;
    sort?: string;
}

const CreditMemoUrl = "/api/v2/creditmemos";

export async function getCreditMemo(
    parameter: CreditMemoParameter & HasOnSuccess<CreditDataResultModel> & HasOnComplete<CreditDataResultModel>,
) {
    const response = await get<SurCreditMemoModel>(CreditMemoUrl, parameter);
    return response;
}
